<template>
  <div>
    <div class="row filters" style="margin:0;position:fixed;bottom:0;width:100%;left:0;z-index:999;">
      <div class="col">
        <b-form-input v-model="filter_address" placeholder="Filter by address"></b-form-input>
      </div>
      <div class="col">
        <b-form-input v-model="filter_protocol" placeholder="Filter by protocol"></b-form-input>
      </div>
      <div class="col">
        <b-form-input v-model="filter_collection" placeholder="Filter by collection"></b-form-input>
      </div>
      <div class="col">
        <b-form-input v-model="filter_refid" placeholder="Filter by reference"></b-form-input>
      </div>
      <div class="col">
        <b-form-input v-model="filter_uuid" placeholder="Filter by UUID"></b-form-input>
      </div>
      <div class="col">
        <div class="btn btn-primary" style="width:100%" @click="filterData">FILTER</div>
      </div>
    </div>

    <div class="container" style="padding-top:10px; padding-bottom:60px;">
      <div class="col-12">
        <div v-if="last.length === 0" style="padding:45vh 0">
          Loading data, please wait...
        </div>

        <div v-if="unconfirmedTxs.length > 0">
          <h3 style="margin-top:30px">Unconfirmed transactions</h3>
          <div v-for="item in unconfirmedTxs" :key="item.uuid">
            <div v-if="item.block === undefined || item.block === null" class="card" style="width:100%;margin-top:20px">
              <div class="card-body">
                <h5 v-if="item.title !== undefined && item.title !== 'undefined' && item.title !== ''" class="card-title"> {{ item.title }} </h5>
                <h5 v-if="item.refID !== undefined && item.refID !== 'undefined' && item.refID !== ''" class="card-title"> {{ item.refID }} </h5>
                <div v-if="item.mime && item.is_file">
                  <img v-if="item.mime.type === 'image'" :src="idanode + '/ipfs/' + item.data" width="100%">
                  IPFS hash: <a :href="idanode + '/ipfs/' + item.data" target="_blank">{{ item.data }}</a><br>
                  <span v-if="item.mime.mime">File Type: {{ item.mime.mime.toUpperCase() }}<br></span>
                </div>
                <p v-if="item.is_file === false" class="card-text">
                  <span v-if="item.protocol"><b>{{ item.protocol }}</b></span>
                  {{ item.data }}
                </p>
                <div style="text-align:center">
                  UUID is <a :href="'/#/uuid/' + item.uuid">{{ item.uuid }}</a><br>
                  Written by <a :href="'/#/address/' + item.address">{{ item.address }}</a>
                </div>
                <hr>
                <div style="text-align:center">
                  <a class="btn btn-primary" style="margin:10px" :href="'/#/uuid/' + item.uuid">Show details</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="last.length > 0">
          <h3 style="margin-top:30px">Confirmed transactions</h3>
          <div v-for="item in last" :key="item.uuid">
            <div v-if="item.block > 0" class="card" style="width:100%;margin-top:20px">
              <div class="card-body">
                <h5 v-if="item.title !== undefined && item.title !== 'undefined' && item.title !== ''" class="card-title"> {{ item.title }} </h5>
                <h5 v-if="item.refID !== undefined && item.refID !== 'undefined' && item.refID !== ''" class="card-title"> {{ item.refID }} </h5>
                <div v-if="item.mime && item.is_file">
                  <img v-if="item.mime.type === 'image'" :src="idanode + '/ipfs/' + item.data" width="100%">
                  IPFS hash: <a :href="idanode + '/ipfs/' + item.data" target="_blank">{{ item.data }}</a><br>
                  <span v-if="item.mime.mime">File Type: {{ item.mime.mime.toUpperCase() }}<br></span>
                </div>
                <div v-if="item.mime && item.protocol === 'documenta://'">
                  <img v-if="item.mime.type === 'image'" :src="item.documentaURL" width="100%">
                  IPFS hash: <a :href="idanode + '/ipfs/' + item.data" target="_blank">{{ item.data }}</a><br>
                  <span v-if="item.mime.mime">File Type: {{ item.mime.mime.toUpperCase() }}<br></span>
                </div>
                <p v-if="item.is_file === false" class="card-text">
                  <span v-if="item.protocol"><b>{{ item.protocol }}</b></span>
                  {{ item.data }}
                </p>
                <div style="text-align:center">
                  UUID is <a :href="'/#/uuid/' + item.uuid">{{ item.uuid }}</a><br>
                  Written by <a :href="'/#/address/' + item.address">{{ item.address }}</a>
                  at block <a :href="'/#/block/' + item.block">{{ item.block }}</a>
                </div>
                <hr>
                <div style="text-align:center">
                  <a class="btn btn-primary" style="margin:10px;font-size:12px;padding:5px 10px" :href="'/#/uuid/' + item.uuid">Show details</a>
                  <a v-if="item.is_file === true" class="btn btn-primary" style="margin:10px" :href="idanode + '/ipfs/' + item.data" target="_blank">Download file</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import bans from '../bans.json'

export default {
  name: 'Explorer',
  data () {
    return {
      idanode: 'https://idanodejs01.scryptachain.org',
      axios: axios,
      last: [],
      bans: bans,
      unconfirmedTxs: [],
      filter_address: '',
      filter_uuid: '',
      filter_collection: '',
      filter_refid: '',
      filter_protocol: ''
    }
  },
  async mounted () {
    this.filterData()
  },
  methods: {
    async filterData () {
      const self = this
      self.last = []
      self.unconfirmedTxs = []

      // Usa window.ScryptaCore (da scryptacore.js) per trovare il nodo
      const node = await window.ScryptaCore.connectNode()
      self.idanode = node

      // Costruisce i parametri del filtro
      const params = {}
      let hasFilter = false
      if (self.filter_protocol !== '') { params.protocol = self.filter_protocol; hasFilter = true }
      if (self.filter_collection !== '') { params.collection = self.filter_collection; hasFilter = true }
      if (self.filter_refid !== '') { params.refID = self.filter_refid; hasFilter = true }
      if (self.filter_uuid !== '') { params.uuid = self.filter_uuid; hasFilter = true }
      if (self.filter_address !== '') { params.address = self.filter_address; hasFilter = true }

      // Chiama direttamente l'idanode via axios
      let response
      try {
        if (!hasFilter) {
          response = await self.axios.post(node + '/read')
        } else {
          response = await self.axios.post(node + '/read', params)
        }
      } catch (e) {
        // errore read
        return
      }

      const data = response.data.data || response.data
      for (const key in data) {
        const item = data[key]
        if (item.uuid === undefined) continue
        if (self.bans.uuids.indexOf(item.uuid) !== -1) continue

        if (item.is_file === true) {
          try {
            const mime = await self.axios.get(node + '/ipfs/type/' + item.data)
            item.mime = mime.data
          } catch (e) { /* ignora */ }
        }

        self.last.push(item)

        if (item.block === undefined || item.block === null) {
          self.unconfirmedTxs.push(item)
        }
      }
    }
  }
}
</script>
